<template>
  <div>
    <v-container>
      <v-row style="height:100vh"></v-row>
      <v-row>
        <v-col class="white--text" style="margin-top:380px">
          <h1 class="text-h2 text-center mt-4">
            Ecobuild Systems
          </h1>
          <h1 class="text-h4 text-center mt-3">
            We build sustainable
          </h1>
          <h2 class="text-h4 text-center mt-2">
            Housing Solutions
          </h2>
          <v-col cols="12 mt-n16 ">
            <v-img src="/images/buildingsv.png"></v-img>
          </v-col>
        </v-col>
        <v-col cols="12" class="white--text" style="margin-top:380px">
          <h2 class="text-h4 mt-2">
            ...by using a <span class="text-h3">revolutionary</span>
          </h2>
          <h2 class="text-h4 mt-2">
            <span class="text-h3">prefabricated</span> assembly system
          </h2>
        </v-col>
      </v-row>
      <v-row>
        <v-col style="margin-top:1450px" class="white--text text-right">
          <h2 class="text-h4 ">
            consisting of
          </h2>
          <h2 class="text-h3"><span class="text-h4">connection</span>Hub</h2>
          <h2 class="text-h3">
            Steel Bars
          </h2>
          <h2 class="text-h3 "><span class="text-h4">and</span> Pannels</h2>
        </v-col>
      </v-row>
    </v-container>
    <v-row class="container-sect">
      <v-container>
        <v-row>
          <!-- <v-spacer /> -->
          <v-col class="white--text text-left">
            <v-row justify="center">
              <h3 class="text-h4" style="h3.line-height:2rem">
                as <span class="text-h3">all structures</span> are
                prefabricated...
              </h3>
            </v-row>
          </v-col>
          <!-- <v-spacer /> -->
          <v-col cols="12" class="my-10">
            <v-img src="/images/cotainer-and-builder.png"></v-img>
          </v-col>
          <v-col class="white--text text-left">
            <v-row justify="center">
              <h3 class="text-h4" style="h3.line-height:1.5rem">
                ...they can be send <span class="text-h3"> globaly</span> and
              </h3>
            </v-row>
          </v-col>
        </v-row>
      </v-container>
    </v-row>
    <v-row style=" " class="text-center white--text">
      <v-col>
        <h3 class="text-h4">
          <span class="text-h3">With</span> this system we can build
        </h3>
        <h3 class="text-h4 mt-3"></h3>
        <h3 class="text-h3">
          <span class="text-h4">incredibly</span> Large Structures like...
        </h3>
      </v-col>
    </v-row>
    <v-container>
      <v-row style="margin-top:800px " class="white--text">
        <v-col>
          <h3 class="text-h3">
            ...this
          </h3>
          <h3 class="text-h4">
            30 foot
          </h3>
          <h3 class="text-h3">
            Pyramid
          </h3>
        </v-col>
      </v-row>
    </v-container>
    <v-container>
      <v-row style="margin-top:1200px " class="white--text text-right">
        <v-col>
          <h3 class="text-h4">
            which was build In
          </h3>
          <h3 class="text-h3">
            Bali, Burning Man
          </h3>
          <h3 class="text-h3"><span class="text-h4">and soon</span> Hawai</h3>
        </v-col>
      </v-row>
      <v-row style="margin-top:1300px" class="white--text ">
        <v-col>
          <h3>you can now enter our</h3>
          <h3 class="text-h3">interactive</h3>
          <h3>presentation</h3>
        </v-col>
      </v-row>
    </v-container>
  </div>
</template>

<script>
export default {}
</script>

<style scoped>
@media screen and (max-width: 1903px) and (min-width: 959px) {
  .container-sect {
    margin-top: 620px;
  }
}

@media screen and (min-width: 1903px) {
  .container-sect {
    margin-top: 400px;
  }
}
</style>
